import { render } from "./TemplateFieldRender.vue?vue&type=template&id=3e72b232&scoped=true"
import script from "./TemplateFieldRender.vue?vue&type=script&lang=js"
export * from "./TemplateFieldRender.vue?vue&type=script&lang=js"

import "./TemplateFieldRender.vue?vue&type=style&index=0&id=3e72b232&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e72b232"]])

export default __exports__